import { Routes as RouterRoutes, Route, Navigate, Outlet } from 'react-router-dom';
import { PatientProtectedRoute } from 'components/PatientProtectedRoute';
import { Layout } from 'components/Layout';
// import { Dashboard } from 'pages/Dashboard';
import { ProtectedResourcePage } from 'components/ProtectedResourcePage';
import { PORTAL_RESOURCE_TYPES } from 'utils/constants';
import AppointmentShow from 'pages/Appointments/Show';
import ConversationShow from 'pages/Conversations/Show';
import Appointments from 'pages/Appointments';
import Conversations from 'pages/Conversations';
import { Toaster } from 'react-hot-toast';

const ProtectedNavShell = () => (
  <PatientProtectedRoute>
    <Layout>
      <Outlet />
    </Layout>
  </PatientProtectedRoute>
);

// Resource show pages — DOB auth gate shown inline if unauthenticated.
// Add a new entry here to support a new resource type.
const RESOURCE_SHOW_PAGES = [
  { type: PORTAL_RESOURCE_TYPES.APPOINTMENTS, element: <AppointmentShow /> },
];

export function Routes() {
  return (
    <>
      <Toaster position="top-right" toastOptions={{ duration: 4000 }} />

      <RouterRoutes>
        {RESOURCE_SHOW_PAGES.map(({ type, element }: any) => (
          <Route
            key={type}
            path={`${type}/:encodedResourceId`}
            element={<ProtectedResourcePage resourceType={type}>{element}</ProtectedResourcePage>}
          />
        ))}

        {/*
          Conversations show page: DOB gate guards only this URL (not the list).
          Wraps <Conversations /> (the sidebar layout) so ConversationShow renders
          inside its Outlet — giving the same split-panel layout as in-app navigation.
        */}
        <Route
          path={`${PORTAL_RESOURCE_TYPES.CONVERSATIONS}/:encodedResourceId`}
          element={
            <ProtectedResourcePage resourceType={PORTAL_RESOURCE_TYPES.CONVERSATIONS}>
              <Conversations />
            </ProtectedResourcePage>
          }
        >
          <Route index element={<ConversationShow />} />
        </Route>

        <Route element={<ProtectedNavShell />}>
          <Route index element={<Navigate to="dashboard" replace />} />
          <Route path="dashboard" element={<Appointments />} />
          <Route path="appointments" element={<Appointments />} />
          <Route path="conversations" element={<Conversations />} />
          <Route path="*" element={<Navigate to="dashboard" replace />} />
        </Route>
      </RouterRoutes>
    </>
  );
}
